import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles(() => ({
    text: {},
    readMore: {
        padding: 0,
        margin: 0,
        background: 'transparent',
        border: 0,
        color: 'inherit',
        textDecoration: 'underline',
    },
}))
